import ReportToolsenseMachine from "./ReportToolsenseMachine";
export default ReportToolsenseMachine;